export default "__VITE_ASSET__BHhcqdsC__"